import React from "react";
import propTypes from "prop-types";
import { assessmentQuestionType, optionType } from "./constants";
import { Table } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { CheckSvgIcn } from "svgIcon";
import { combineDateAndTime, htmlParser } from "utils/helper";
const AnsQuestionComponents = ({ questionData }) => {
  const {
    question_type,
    answer,
    options,
    max_value,
    min_value,
    column_value,
    row_value,
    text_to_appear,
    question_to_appear,
    checkbox_question_dynamic_data,
    checkbox_label,
  } = questionData;

  switch (question_type) {
    case assessmentQuestionType.freeText:
    case assessmentQuestionType.textarea:
    case assessmentQuestionType.checkboxText:
    case assessmentQuestionType.textOnly:
      return (
        <div className="qtype__one">
          <p>
            {assessmentQuestionType.checkboxText === question_type
              ? text_to_appear
              : answer
              ? htmlParser(answer.split("\n").join("<br />"))
              : ""}
          </p>
        </div>
      );
    case assessmentQuestionType.Checkboxes:
    case assessmentQuestionType.dropDown:
      let option_data = options.split(",");
      let answer_arr = answer ? answer.split(",") : [];
      return (
        <>
          <div className="qtype__two">
            {option_data?.length ? (
              <>
                <ul class="multi__list m-0 ps-2">
                  {option_data.map((item, i) => {
                    return (
                      <li
                        class={`position-relative ${
                          answer_arr.includes(item) ? "active" : ""
                        }`}
                      >
                        {item}
                      </li>
                    );
                  })}
                </ul>
              </>
            ) : (
              ""
            )}
          </div>
        </>
      );
    case assessmentQuestionType.CheckboxesFurtherInfo:
      try {
        const parsedAnswer = JSON.parse(answer);
        return (
          <>
            {Array.isArray(parsedAnswer) && (
              <div className="qtype__five">
                <ul class="asseqt__list m-0 ps-2">
                  {parsedAnswer.map(
                    ({ option, answer, question, is_checked }, i) => (
                      <>
                        {is_checked ? (
                          <>
                            <li class="position-relative active">
                              <p className="mb-1">{option}</p>
                              <div className="qtype__card">
                                <p className="text-dark fw-semibold">
                                  {question}
                                </p>
                                <p className="fw-normal text-gray mt-2">
                                  {answer}
                                </p>
                              </div>
                            </li>
                          </>
                        ) : (
                          <li class="position-relative">{option}</li>
                        )}
                      </>
                    )
                  )}
                </ul>
              </div>
            )}
          </>
        );
      } catch (error) {
        return;
      }
    case assessmentQuestionType.linearScale:
      return (
        <>
          <div className="qtype__six">
            <div className="range__slider d-flex align-items-center gap-2 position-relative">
              <p className="mb-0 taxt-dark fw-bold">{min_value}</p>
              <div className="position-relative w-100">
                <Form.Range
                  disabled
                  value={answer ? answer : 0}
                  min={min_value}
                  max={max_value}
                  style={{
                    pointerEvents: "none",
                  }}
                />
                {answer ? (
                  <div
                    className="slider-tooltip position-absolute"
                    style={{
                      left: `${
                        ((answer - min_value) / (max_value - min_value)) * 100
                      }%`,
                      top: "3px",
                      fontWeight: "bold",
                      width: "22px",
                      textAlign: "center",
                      marginTop: "0",
                      marginLeft: "-0.8%",
                    }}
                  >
                    {answer}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <p className="mb-0 taxt-dark fw-bold">{max_value}</p>
            </div>
          </div>
        </>
      );
    case assessmentQuestionType.multipleChoiceGrid:
    case assessmentQuestionType.tickBoxGrid:
      let anserwerGrid = JSON.parse(answer);
      return (
        <>
          <div className="qtype__three">
            <Table striped className="overflow-hidden mb-0">
              <thead>
                <tr>
                  <th></th>
                  {column_value.map((col, c) => {
                    return (
                      <th className="text-center" key={c}>
                        {col}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {row_value.map((row, r) => {
                  var row_anser =
                    anserwerGrid && anserwerGrid.length
                      ? anserwerGrid.filter((item, ai) => item[0] === r)
                      : [];

                  return (
                    <tr key={r}>
                      <td>{row}</td>
                      {column_value.map((col, c) => {
                        let answerFilter =
                          row_anser && row_anser.length
                            ? row_anser.filter(
                                (raItem, rai) => parseInt(raItem[1]) === c
                              )
                            : [];
                        return (
                          <td className="text-center">
                            {answerFilter && answerFilter.length ? (
                              <CheckSvgIcn />
                            ) : (
                              "-"
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </>
      );
    case assessmentQuestionType.date:
    case assessmentQuestionType.dateAndTime:
      return (
        <>
          <div className="qtype__four">
            {question_type === assessmentQuestionType.dateAndTime ? (
              <p>
                {answer
                  ? combineDateAndTime(answer, "", "current", "D M Y H:m", true)
                  : ""}
              </p>
            ) : (
              <p>
                {answer
                  ? combineDateAndTime(answer, "", "current", "D M Y")
                  : ""}
              </p>
            )}
          </div>
        </>
      );
    case assessmentQuestionType.checkboxQuestion:
      return (
        <>
          <div className="qtype__five">
            <ul class="asseqt__list m-0 ps-2">
              <li class={`position-relative ${answer ? "active" : ""}`}>
                <p className="mb-1">{checkbox_label}</p>
                <div className="qtype__card">
                  <p className="text-dark fw-semibold">{question_to_appear}</p>
                  <p className="fw-normal text-gray mt-2">{answer}</p>
                </div>
              </li>
            </ul>
          </div>
        </>
      );
    case assessmentQuestionType.CheckboxesQuestionDynamic:
      return (
        <>
          <div className="qtype__five">
            <ul class="asseqt__list m-0 ps-2">
              <li class={`position-relative ${answer ? "active" : ""}`}>
                <p className="mb-1">{checkbox_label}</p>
                <div className="qtype__card">
                  <p className="text-dark fw-semibold">
                    {checkbox_question_dynamic_data.question}
                  </p>
                  <AnsQuestionComponents
                    questionData={{
                      ...checkbox_question_dynamic_data,
                      answer: answer,
                    }}
                  />
                </div>
              </li>
            </ul>
          </div>
        </>
      );
    default:
      return (
        <div className="qtype__one">
          <p>{answer}</p>
        </div>
      );
  }
};
AnsQuestionComponents.propTypes = {
  history: propTypes.object,
};
export default AnsQuestionComponents;
